<template>
<!-- eslint-disable -->
  <div class="open-services">
    <NavBar></NavBar>
    <StatusBar></StatusBar>
    <main
      property="mainContentOfPage"
      class="container"
      typeof="WebPageElement"
    >
      <section class="custom-section mt-6">
        <div class="columns">
          <div class="column is-7">
            <h1 class="title is-2">{{ $t("open_services.title") }}</h1>
            <p class="large-text" v-html="$t('open_services.description')"></p>
          </div>
          <div class="column is-5">
            <StatusBox />
          </div>
        </div>
      </section>
      <section class="custom-section mt-4 mb-6">
        <div class="tile is-ancestor">
          <!-- disabled until API store is ready to launch -->
          <!--
          <BaseTile>
            <template v-slot:headertext
              ><h2 class="title is-4">
                {{ $t("open_services.data_api.title") }}
              </h2></template
            >
            <template v-slot:bodytext>{{
              $t("open_services.data_api.text")
            }}</template>
            <template v-slot:footertext>
              <router-link
                to="/api-catalogue"
                v-slot="{ href, route, navigate }"
              >
                <b-button
                  disabled
                  :href="href"
                  @click="navigate"
                  class="is-primary"
                >
                  {{ $t("message.on_roadmap") }}
                </b-button>
              </router-link>
            </template>
          </BaseTile>
          -->
          <BaseTile>
            <template v-slot:headertext>
              <h2 class="title is-4">
                {{ $t("open_services.widgets.title") }}
              </h2></template
            >
            <template v-slot:bodytext><p class="is-size-5">{{
              $t("open_services.widgets.text")
            }}</p></template>
            <template v-slot:footertext>
              <router-link to="/widgets" v-slot="{ href, route, navigate }">
                <b-button :href="href" @click="navigate" class="is-primary">
                  {{ $t("open_services.widgets.btn") }}
                </b-button>
              </router-link>
            </template>
          </BaseTile>
          <!-- disabled until IM Toolbox is ready to launch -->
          <BaseTile>
            <template v-slot:headertext
              ><h2 class="title is-4">
                {{ $t("open_services.pub_tools.title") }}
              </h2></template
            >
            <template v-slot:bodytext><p class="is-size-5">{{
              $t("open_services.pub_tools.text")
            }}</p></template>
            <template v-slot:footertext>
              <router-link
                to="/publishing-tools"
                v-slot="{ href, route, navigate }"
              >
                <b-button
                  disabled
                  :href="href"
                  @click="navigate"
                  class="is-primary"
                >
                  {{ $t("message.on_roadmap") }}
                </b-button>
              </router-link></template
            >
          </BaseTile>
        </div>
      </section>
    </main>

    <BaseFooter></BaseFooter>
  </div>
</template>

<script>
import StatusBox from "@/components/StatusBox.vue";
import BaseTile from "@/components/base-components/BaseTile.vue";
import NavBar from "@/components/NavBar.vue";
import BaseFooter from "@/components/Footer.vue";
import StatusBar from "@/components/StatusBar.vue";

export default {
  name: "open-services",

  components: {
    StatusBox,
    BaseTile,
    NavBar,
    BaseFooter,
    StatusBar
  },
  created() {
    document.title = this.$t("open_services.title");
  },
  updated() {
    document.title = this.$t("open_services.title");
  }
};
</script>

<style scoped>
.titleHide {
  color: white;
}
</style>
